<div class="AMScannPassportModal">
  <div class="AMScannPassportModal-video">
    <am-show-video fileName="AmKioskoPasaporteEmbross_" [widthVideo]="928"></am-show-video>
  </div>
  <div class="bg-am-darkblue text-am-white fs-22px AMScannPassportModal-info" [ngSwitch]="status">
    <div *ngSwitchCase="'wait'">{{ 'videoScanner.wait' | translate}}</div>
    <div *ngSwitchCase="'process'" class="process">
      <div class="loadingio-spinner-bars">
        <div class="ldio-lr2dvv8fpg">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <span>{{ 'videoScanner.scannerPassport' | translate }}</span>
    </div>
    <div *ngSwitchCase="'success'"> <img src="assets/images/success.svg"> {{'videoScanner.verifiedPassport' | translate}}</div>
    <div *ngSwitchCase="'error'"><img src="assets/images/error.svg"> {{ 'videoScanner.errorPassport' | translate }}</div>
  </div>
  <div class="AMScannPassportModal-footer">
    <p class="text-decoration-underline fs-5 mb-0 text-am-white" *ngIf="status !== 'error'"
      (click)="onToCapturePassport()">
      {{ 'videoScanner.manualPassport' | translate }}
    </p>
    <div class="AMScannPassportModal-footer-reset" *ngIf="status == 'error'">
      <button class="am-button am-button-ligth" (click)="onToCapturePassport()">{{ 'videoScanner.enterManually' | translate }}</button>
      <button class="am-button am-button-red" (click)="onReadPassport()">{{ 'videoScanner.enterError' | translate }}</button>
    </div>
  </div>

</div>
